import httpClient from '../utils/httpClient';


// list groups for org
export async function listGroups(orgId) {
    const r = await httpClient.get(`/api/org/${orgId}/groups`);
    return r.data;
  }
  
  //  get one group details
  export async function getGroup(orgId, groupId) {
    const r = await httpClient.get(`/api/org/${orgId}/groups/${groupId}`);
      return r.data;
  }
/**
 * Create a group in an org
 * POST /api/org/:orgId/groups
 * body: { name: string, type?: 'classroom'|'team'|'cohort'|'program'|'department' }
 */
export async function createGroup(orgId, payload) {
  const { data } = await httpClient.post(`/api/org/${orgId}/groups`, payload);
  return data;
}

/**
 * Update a group
 * PATCH /api/org/:orgId/groups/:groupId
 * body: { name?: string, type?: 'classroom'|'team'|'cohort'|'program'|'department' }
 */
export async function updateGroup(orgId, groupId, payload) {
  const { data } = await httpClient.patch(`/api/org/${orgId}/groups/${groupId}`, payload);
  return data;
}

/**
 * Delete a group
 * DELETE /api/org/:orgId/groups/:groupId
 */
export async function deleteGroup(orgId, groupId) {
  const { data } = await httpClient.delete(`/api/org/${orgId}/groups/${groupId}`);
  return data;
}

/**
 * Remove a member from a group
 * DELETE /api/org/:orgId/groups/:groupId/members/:userId
 */
export async function removeGroupMember(orgId, groupId, userId) {
  const { data } = await httpClient.delete(`/api/org/${orgId}/groups/${groupId}/members/${userId}`);
  return data;
}

/**
 * Update a member's role inside a group
 * PATCH /api/org/:orgId/groups/:groupId/members/:userId/role
 * body: { role: 'admin'|'member' }
 */
export async function updateGroupMemberRole(orgId, groupId, userId, role) {
  const { data } = await httpClient.patch(
    `/api/org/${orgId}/groups/${groupId}/members/${userId}/role`,
    { role }
  );
  return data;
}


// get group members (for viewing)
export async function getGroupMembers(orgId, groupId, options = {}) {
  const params = {};
  if (options.page) params.page = options.page;
  if (options.pageSize) params.pageSize = options.pageSize;

  const r = await httpClient.get(`/api/org/${orgId}/groups/${groupId}/members`, { params });
  return r.data;
}

// api/groupApi.js

export async function getMeetingAssignees(orgId, groupId, meetingId) {
  const r = await httpClient.get(
    `/api/org/${orgId}/groups/${groupId}/meetings/${meetingId}/assignees`
  );
  return r.data; // array of assignee objects
}

  // Get group meetings (for viewing)
  // options: { mine?: boolean }
  export async function getGroupMeetings(orgId, groupId, options = {}) {
    const params = {};
    if (options.mine === true) params.mine = true;
  
    // ✅ pagination (optional)
    if (options.page) params.page = options.page;
    if (options.pageSize) params.pageSize = options.pageSize;
  
    const r = await httpClient.get(`/api/org/${orgId}/groups/${groupId}/meetings`, { params });
    return r.data;
  }
  /**
 * Create a sharable invite link for a group.
 * Backend should require org admin or group admin.
 *
 * POST /api/org/:orgId/groups/:groupId/invite-links
 * body: { groupRole: 'admin'|'member', expiresInDays?: number }
 * returns: { inviteLinkId, inviteUrl, token, expiresAt? }
 */
export async function createGroupInviteLink(orgId, groupId, payload) {
    const { data } = await httpClient.post(
      `/api/org/${orgId}/groups/${groupId}/invite-link`,
      payload
    );
    return data;
  }

  /**
 * Accept a sharable invite link.
 * Requires auth cookie (SSO user already logged in).
 *
 * POST /api/org/groups/invite-links/accept
 * body: { token: string }
 * returns: { message, orgId, groupId, role }
 */
  export async function acceptGroupInviteLink(token) {
    const { data } = await httpClient.post(
      `/api/org/groups/invite-link/accept-link`,
      { token }
    );
    return data;
  }

  /**
 * Invite an existing ORG member to a GROUP via email invite.
 * Backend enforces: user must exist + already be org member.
 *
 * POST /api/org/:orgId/groups/:groupId/invite-email
 * body: { email: string, groupRole: 'admin'|'member' }
 */
export async function inviteGroupMemberEmail(orgId, groupId, payload) {
    const { data } = await httpClient.post(
      `/api/org/${orgId}/groups/${groupId}/invite-email`,
      payload
    );
    return data;
  }
  
/** Accept an emailed invite (token from email link) */
export async function acceptGroupInviteEmail(token) {
  const { data } = await httpClient.post(
    `/api/org/groups/invite-email/accept-invite-email`, // OR your existing '/accept-invite-email'
    { token }
  );
  return data; // { message, orgId, groupId, role }
}

export async function deleteAssignedPracticeMeeting(orgId, groupId, meetingId) {
  const r = await httpClient.delete(
    `/api/org/${orgId}/groups/${groupId}/meetings/${meetingId}`
  );
  return r.data;
}

export async function updateAssignedPracticeMeeting(orgId, groupId, meetingId, payload) {
  const r = await httpClient.patch(
    `/api/org/${orgId}/groups/${groupId}/meetings/${meetingId}`,
    payload
  );
  return r.data;
}